import { Injectable, inject, signal } from '@angular/core'
import { Router } from '@angular/router'
import { OCC_USER_ID_ANONYMOUS, OCC_USER_ID_CURRENT, User, WindowRef } from '@spartacus/core'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { Observable, of, pairwise, shareReplay, startWith, switchMap, takeWhile } from 'rxjs'
import { CustomAuthService } from './auth.service'

@Injectable({ providedIn: 'root' })
export class CustomUserService {
  private readonly userAccountService = inject(UserAccountFacade)
  private readonly authService = inject(CustomAuthService)
  private readonly router = inject(Router)
  private readonly winRef = inject(WindowRef)

  private alreadyFetchedUser = signal(false)

  user$: Observable<User | undefined> = this.authService.isUserLoggedIn().pipe(
    startWith(false),
    pairwise(),
    switchMap(([wasLoggedIn, isLoggedIn]) => {
      if (isLoggedIn) {
        return this.getUser()
      } else {
        if (wasLoggedIn) {
          this.alreadyFetchedUser.set(false)
        }

        return of(undefined)
      }
    }),
    shareReplay(1)
  )

  private getUser (): Observable<User | undefined> {
    if (this.alreadyFetchedUser()) return this.user$

    // check if asm (url and asm-ui)
    const isAsmUrl = this.router.url.includes('?asm=true')
    let hasAsmElement = false

    if (this.winRef.isBrowser()) {
      hasAsmElement = !!this.winRef.document.querySelector('cx-asm-main-ui')
    }

    const isAsm = isAsmUrl || hasAsmElement

    this.alreadyFetchedUser.set(true)
    return this.userAccountService.getById(isAsm ? OCC_USER_ID_ANONYMOUS : OCC_USER_ID_CURRENT).pipe(
      takeWhile(user => !user, true),
      switchMap(user => user ? of(user) : this.getUser())
    )
  }
}
